
import {ExternalCodeModel} from "@white-label/components/page-builder/models/external-code.model";
import {ContactsModel} from "@white-label/components/page-builder/models/contacts.model";
import {CarouselModel} from "@white-label/components/page-builder/models/carousel.model";
import {CardGridModel} from "@white-label/components/page-builder/models/card-grid.model";
import {AiModel} from "@white-label/components/page-builder/models/ai/ai.model";
import {SubscriptionModel} from "@white-label/components/page-builder/models/subscription.model";
import {CardModel} from "@white-label/components/page-builder/models/card.model";
import {NavigationCategory} from "@white-label/components/page-builder/models/navigation.model";
import {BannerModel} from "@white-label/components/page-builder/models/banner.model";
import {SponsorModel, SponsorsModel} from "@white-label/components/page-builder/models/sponsors.model";
import {TextModel} from "@white-label/components/page-builder/models/text.model";
import {
    ContactModel,
    HeaderStatsBannerModel, StatsModel
} from "@white-label/components/page-builder/models/header-stats-banner.model";
import {FaqModel, OneQuestion} from "@white-label/components/page-builder/models/faq.model";
import {OneReview, ReviewsModel} from "@white-label/components/page-builder/models/reviews.model";
import {CardCarouselModel} from "@white-label/components/page-builder/models/card-carousel.model";
import {HowItWorksModel, HowItWorksStepModel} from "@white-label/components/page-builder/models/how-it-works.model";
import {OneStatModel, StatisticsModel} from "@white-label/components/page-builder/models/stats.model";
import {DonationWidgetModel} from "@white-label/components/page-builder/models/donation-widget.model";
import {HeaderLiveBannerModel} from "@white-label/components/page-builder/models/header-live-banner.model";

export enum ComponentTypes {
    hero = 'hero',

    banner = 'banner',
    carousel = 'carousel',
    hero_simple_app = 'hero_simple_app',
    hero_product = 'hero_product',
    hero_live_stream = 'hero_live_stream',
    hero_slider = 'hero_slider',
    hero_video = 'hero_video',
    banner_left_right = 'banner_left_right',
    banner_right_left = 'banner_right_left',


    stats = 'stats',
    how_it_works = 'how_it_works',


    features = 'features',
    sponsor = 'sponsor',
    faq = 'faq',
    latestProducts = 'latestProducts',
    portfolio = 'portfolio',
    text = 'text',
    reviews = 'reviews',
    externalCode = 'externalCode',
    contactUs = 'contactUs',
    aiComponent = 'aiComponent',
    pricing = 'pricing',


    grid = 'grid',
    horizontalCarousel = 'horizontal_carousel',
    verticalCarousel = 'vertical_carousel',

    donationWidget = 'donation_widget'
}


export enum NestedFieldTypes {
    question = 'question',
    review = 'review',
    stat = 'stat',
    contact = 'contact',
    sponsor = 'sponsor',


    statsOneStat = 'statsOneStat',
    howItWorksStep = 'howItWorksStep',

    navigationCategory = 'navigationCategory',

    card = 'card',
}

export enum FieldType {
    embed = 'embed',
    page = 'page',
    number = 'number',
    boolean = 'boolean',
    cardType = 'cardType',
    size = 'size',
    color = 'color',
    array = 'array',
    category = 'category',
    nested = 'nested',
    countries = 'countries',
    html = 'html',
    aiComponentEditor = 'aiComponentEditor',
    phone = 'phone',
    email = 'email',
    hidden = 'hidden',
    ai = 'ai',
    products = 'products',


    file = 'file',
    image = 'image',
    textarea = 'textarea',
    link = 'link',
    video = 'video',
    media = 'media',
    text = 'text',
    icon = 'icon',
}

export class OptionItem {
    key?: any;
    value?: any;
}

export const ModelComponentsMap = {
    [ComponentTypes.banner_left_right] : BannerModel,
    [ComponentTypes.banner_right_left] : BannerModel,
    [ComponentTypes.hero_slider] : CarouselModel,
    [ComponentTypes.hero_product] : BannerModel,
    [ComponentTypes.hero_live_stream] : HeaderLiveBannerModel,
    [ComponentTypes.hero_video] : BannerModel,
    [ComponentTypes.hero_simple_app] : BannerModel,
    [ComponentTypes.hero] : HeaderStatsBannerModel,
    [ComponentTypes.sponsor] : SponsorsModel,
    [ComponentTypes.faq] : FaqModel,
    [ComponentTypes.latestProducts] : null,
    [ComponentTypes.donationWidget]: DonationWidgetModel,
    [ComponentTypes.portfolio] : null,
    [ComponentTypes.text] : TextModel,
    [ComponentTypes.reviews] : ReviewsModel,
    [ComponentTypes.externalCode] : ExternalCodeModel,
    [ComponentTypes.contactUs] : ContactsModel,
    [ComponentTypes.horizontalCarousel] : CardCarouselModel,
    [ComponentTypes.grid] : CardGridModel,
    [ComponentTypes.aiComponent] : AiModel,
    [ComponentTypes.pricing] : SubscriptionModel,

    [ComponentTypes.how_it_works] : HowItWorksModel,
    [ComponentTypes.stats] : StatisticsModel,
}


export const NestedModelMap = {
    [NestedFieldTypes.contact] : ContactModel,
    [NestedFieldTypes.question] : OneQuestion,
    [NestedFieldTypes.stat] : StatsModel,
    [NestedFieldTypes.card] : CardModel,
    [NestedFieldTypes.sponsor] : SponsorModel,
    [NestedFieldTypes.statsOneStat] : OneStatModel,
    [NestedFieldTypes.howItWorksStep] : HowItWorksStepModel,
    [NestedFieldTypes.navigationCategory] : NavigationCategory,
    [NestedFieldTypes.review] : OneReview
}